// import React, { useMemo } from "react";
// import { Drawer, Stack, Box, Typography } from "@mui/material";
// import { usePathname } from "hooks/use-pathname";
// import MobileNavSection from "./MobileNavSection";
// import { useTheme } from "@mui/material/styles";
// // import GlydeBirdLogo from "assets/icons/glyde-bird-logo.svg";
// import { Section } from "layouts/Config";

// const MOBILE_NAV_WIDTH = 280;

// const useCssVars = (): Record<string, string> => {
//   const theme = useTheme();

//   return useMemo((): Record<string, string> => {
//     if (theme.palette.mode === "dark") {
//       return {
//         "--nav-bg": theme.palette.background.default,
//         "--nav-color": theme.palette.neutral[100],
//         "--nav-divider-color": theme.palette.neutral[800],
//         "--nav-border-color": theme.palette.neutral[700],
//         "--nav-logo-border": theme.palette.neutral[700],
//         "--nav-item-color": theme.palette.neutral[400],
//         "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
//         "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
//         "--nav-item-active-color": theme.palette.text.primary,
//         "--nav-item-disabled-color": theme.palette.neutral[600],
//         "--nav-item-icon-color": theme.palette.neutral[500],
//         "--nav-item-icon-active-color": theme.palette.primary.main,
//         "--nav-item-icon-disabled-color": theme.palette.neutral[700],
//         "--nav-item-chevron-color": theme.palette.neutral[700],
//         "--nav-scrollbar-color": theme.palette.neutral[400],
//       };
//     } else {
//       return {
//         "--nav-bg": theme.palette.background.default,
//         "--nav-color": theme.palette.text.primary,
//         "--nav-divider-color": theme.palette.divider,
//         "--nav-border-color": theme.palette.neutral[100],
//         "--nav-logo-border": theme.palette.neutral[100],
//         "--nav-section-title-color": theme.palette.neutral[400],
//         "--nav-item-color": theme.palette.text.secondary,
//         "--nav-item-hover-bg": theme.palette.action.hover,
//         "--nav-item-active-bg": theme.palette.action.selected,
//         "--nav-item-active-color": theme.palette.text.primary,
//         "--nav-item-disabled-color": theme.palette.neutral[400],
//         "--nav-item-icon-color": theme.palette.neutral[400],
//         "--nav-item-icon-active-color": theme.palette.primary.main,
//         "--nav-item-icon-disabled-color": theme.palette.neutral[400],
//         "--nav-item-chevron-color": theme.palette.neutral[400],
//         "--nav-scrollbar-color": theme.palette.neutral[900],
//       };
//     }
//   }, [theme]);
// };

// interface CustomProps {
//   onClose?: () => void;
//   open?: boolean;
//   sections?: Section[];
// }

// const MobileNav = (props: CustomProps) => {
//   const pathname = usePathname();
//   const cssVars = useCssVars();

//   return (
//     <Drawer
//       anchor="left"
//       onClose={props.onClose}
//       open={props.open}
//       PaperProps={{
//         sx: {
//           ...cssVars,
//           backgroundColor: "var(--nav-bg)",
//           color: "var(--nav-color)",
//           width: MOBILE_NAV_WIDTH,
//         },
//       }}
//       variant="temporary"
//     >
//       <Stack sx={{ height: "100%" }}>
//         <Stack alignItems="center" direction="row" spacing={2} sx={{ p: 3 }}>
//           <Box
//             sx={{
//               borderColor: "var(--nav-logo-border)",
//               borderRadius: 1,
//               borderStyle: "solid",
//               borderWidth: 1,
//               display: "flex",
//               height: 40,
//               p: "4px",
//               width: 40,
//             }}
//           >
//             {/* <img src={GlydeBirdLogo} /> */}
//           </Box>
//           <Stack alignItems="center" direction="row" spacing={2} {...props}>
//             <Box sx={{ flexGrow: 1 }}>
//               <Typography color="inherit" variant="h6">
//                 Glyde
//               </Typography>
//               <Typography color="neutral.400" variant="body2">
//                 Merchant Portal
//               </Typography>
//             </Box>
//           </Stack>
//         </Stack>
//         <Stack
//           component="nav"
//           spacing={2}
//           sx={{
//             flexGrow: 1,
//             px: 2,
//           }}
//         >
//           {(props.sections ?? []).map((section, index) => (
//             <MobileNavSection
//               items={section.items}
//               key={index}
//               pathname={pathname}
//               subheader={section.subheader}
//             />
//           ))}
//         </Stack>
//         <Box sx={{ p: 3 }}>
//           {/* <Typography color="neutral.400" variant="subtitle1">
//               Need help?
//             </Typography>
//             <Typography color="neutral.400" sx={{ mb: 2 }} variant="body2">
//               Please check our docs.
//             </Typography>
//             <Button
//               component="a"
//               fullWidth
//               href={paths.docs}
//               startIcon={
//                 <SvgIcon>
//                   <File04Icon />
//                 </SvgIcon>
//               }
//               target="_blank"
//               variant="contained"
//             >
//               Documentation
//             </Button> */}
//         </Box>
//       </Stack>
//     </Drawer>
//   );
// };

// export default MobileNav;

import { useMemo } from "react";
import { Drawer, Box, Stack } from "@mui/material";
import { Section, useAuthRouteRedirection } from "../../Config";
import { usePathname } from "hooks/use-pathname";
import MobileNavSection from "./MobileNavSection";
import { useTheme } from "@mui/material/styles";
import history from "utils/history";
import { useAppSelector } from "utils/hooks";
import { selectTheme } from "redux/preferencesSlice";
import Dark_Theme_Logo from "assets/images/dark_side_nav_mailzzy_logo.svg";
import Light_Theme_Logo from "assets/images/light_side_nav_mailzzy_logo.svg";

const MOBILE_NAV_WIDTH = 280;

const useCssVars = (): Record<string, string> => {
  const theme = useTheme();
  const themePreference = useAppSelector(selectTheme);

  return useMemo((): Record<string, string> => {
    if (themePreference === "dark") {
      return {
        "--nav-bg": theme.palette.background.default,
        "--nav-color": theme.palette.neutral[100],
        "--nav-divider-color": theme.palette.neutral[800],
        "--nav-border-color": theme.palette.neutral[700],
        "--nav-logo-border": theme.palette.neutral[700],
        "--nav-item-color": theme.palette.neutral[400],
        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
        "--nav-item-active-color": theme.palette.text.primary,
        "--nav-item-disabled-color": theme.palette.neutral[600],
        "--nav-item-icon-color": theme.palette.neutral[500],
        "--nav-item-icon-active-color": theme.palette.primary.main,
        "--nav-item-icon-disabled-color": theme.palette.neutral[700],
        "--nav-item-chevron-color": theme.palette.neutral[700],
        "--nav-scrollbar-color": theme.palette.neutral[400],
      };
    } else {
      return {
        "--nav-bg": "#242A3A",
        "--nav-color": "#FFFFFF",
        "--nav-divider-color": theme.palette.divider,
        "--nav-border-color": theme.palette.neutral[100],
        "--nav-logo-border": theme.palette.neutral[100],
        "--nav-section-title-color": theme.palette.neutral[400],
        "--nav-item-color": "#5E6979",
        "--nav-item-hover-bg": "#474C5B",
        "--nav-item-active-bg": "#474C5B",
        "--nav-item-active-color": "#FFFFFF",
        "--nav-item-disabled-color": theme.palette.neutral[400],
        "--nav-item-icon-color": "#5E6979",
        "--nav-item-icon-active-color": "#FFFFFF",
        "--nav-item-icon-disabled-color": theme.palette.neutral[400],
        "--nav-item-chevron-color": theme.palette.neutral[400],
        "--nav-scrollbar-color": theme.palette.neutral[900],
      };
    }
  }, [theme]);
};

interface CustomProps {
  onClose?: () => void;
  open?: boolean;
  sections?: Section[];
}

const MobileNav = (props: CustomProps) => {
  const pathname = usePathname();
  const cssVars = useCssVars();
  const authRoute = useAuthRouteRedirection();
  const themePreference = useAppSelector(selectTheme);

  return (
    <Drawer
      anchor="left"
      onClose={props.onClose}
      open={props.open}
      PaperProps={{
        sx: {
          ...cssVars,
          backgroundColor: "var(--nav-bg)",
          color: "var(--nav-color)",
          width: MOBILE_NAV_WIDTH,
        },
      }}
      variant="temporary"
    >
      <Stack sx={{ height: "100%" }}>
        <Stack alignItems="center" direction="row" spacing={2} sx={{ p: 3 }}>
          <Box onClick={() => history.push(authRoute)}>
            <img
              src={
                themePreference === "dark" ? Dark_Theme_Logo : Light_Theme_Logo
              }
              style={{ width: "180px" }}
            />
          </Box>
        </Stack>
        <Stack
          component="nav"
          spacing={2}
          sx={{
            flexGrow: 1,
            px: 2,
            pt: 4,
          }}
        >
          {(props.sections ?? []).map((section, index) => (
            <MobileNavSection
              items={section.items}
              key={index}
              pathname={pathname}
              subheader={section.subheader}
            />
          ))}
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default MobileNav;
